// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"40790043","136":"849de087","180":"e4301ae2","229":"e233efe9","249":"772bb791","349":"6fd8333f","453":"f2b619a6","554":"82893973","687":"e42b6e4f","813":"c936003a","821":"3b683b53","963":"2333c43f","989":"df8a32d4"}[chunkId] + ".chunk.js";
};